<template>
  <div class="dropDown">
    <div
      :class="[
        userInfo.enterprisePackage === 3 ||
        userInfo.enterprisePackage === 6 ||
        tabulationItem.vip
          ? 'drop-top vip-bg pb0'
          : 'drop-top pb0'
      ]"
    >
      <div class="drop-header">
        <img
          class="defaultHead"
          :src="
            userInfo.avatar ||
              require('../../assets/img/headers/drop/defaultHead.svg')
          "
          alt="头像"
        />
        <div class="info-box">
          <div class="top">
            <h2>{{ userInfo.nickName }}</h2>
            <span
              v-if="userInfo.roleName"
              :class="[tabulationItem && tabulationItem.vip ? 'vip' : 'normal']"
              >{{
                userInfo.roleName !== "admin" ? "企业成员" : "企业管理员"
              }}</span
            >
            <img
              v-if="!userInfo.roleName && tabulationItem && tabulationItem.vip"
              src="../../assets/img/headers/drop/vip.png"
              alt=""
            />
          </div>
          <div class="bottom">
            <div>
              <img
                class="icon"
                v-if="
                  [
                    'wechat_oauth',
                    'wechat_qr',
                    'wechat_official_qr',
                    'wechat_work_qr',
                    'wechat_mini_program',
                    'wechat_mini_program_code'
                  ].includes(currentUser && currentUser.authType)
                "
                src="../../assets/img/headers/wechat.svg"
                alt=""
              />
              <img
                v-else-if="
                  ['qq_mobile_oauth', 'qq_oauth'].includes(
                    currentUser && currentUser.authType
                  )
                "
                class="icon"
                src="../../assets/img/headers/qq.svg"
                alt=""
              />
              <img
                v-else-if="
                  currentUser && currentUser.authType === 'foxit_oauth'
                "
                class="icon"
                src="../../assets/img/headers/foxit.svg"
                alt=""
              />
              <img
                v-else-if="
                  ['weibo_oauth', 'weibo_mobile_oauth'].includes(
                    currentUser && currentUser.authType
                  )
                "
                class="icon"
                src="../../assets/img/headers/weibo.svg"
                alt=""
              />
              <img
                v-else-if="currentUser && currentUser.authType === 'sms'"
                class="icon"
                src="../../assets/img/headers/phone.svg"
                alt=""
              />
              <img
                v-else
                class="icon"
                src="../../assets/img/headers/lock.svg"
                alt=""
              />
              <span>{{
                userInfo.accountType === "PERSONAL" ? "个人账号" : "企业账号"
              }}</span>
            </div>
            <span class="id"
              >ID：{{
                userInfo.accountType === "PERSONAL"
                  ? userInfo.userId
                  : (currentUser && currentUser.accountId) || userInfo.userId
              }}</span
            >
          </div>
        </div>
      </div>
      <div class="equity-box" :class="`${tabulationItem.class}`">
        <div>
          <h6>
            {{ tabulationItem.packageName }}
            <span class="expiredTime"
              >{{ getVipExpireTime || ""
              }}{{ (getVipExpireTime && "到期") || "" }}</span
            >
          </h6>
          <p>
            {{ tabulationItem.describe }}
          </p>
        </div>
        <a
          v-if="tabulationItem.payLink"
          :class="
            userInfo.enterprisePackage === 3 ||
            userInfo.enterprisePackage === 6 ||
            tabulationItem.vip
              ? 'vip'
              : ''
          "
          :href="tabulationItem.payLink"
          target="_blank"
          >{{ tabulationItem.buttonText }}</a
        >
      </div>
      <div class="warn-tip" v-if="!isCertification && showCertification">
        <div class="warn-tip-text">
          <img
            src="../../assets/img/headers/drop/tip-icon.png"
            alt="安全风险"
          />
          <p>安全风险：您的账号还未绑定手机号，</p>
          <a href="https://account.foxitreader.cn/usercenter/" target="_blank"
            >请绑定</a
          >
        </div>
        <div class="close" @click="closeCertification">
          <img src="../../assets/img/headers/drop/close.png" alt="" />
        </div>
      </div>
    </div>
    <ul class="tabulation">
      <li v-for="item in dropDownTabulation" :key="item.packageId">
        <a :href="item.url" :title="item.text" target="_blank">
          <img :src="item.img" :alt="item.text" :title="item.text" />
          <span>{{ item.text }}</span>
        </a>
      </li>
    </ul>
    <div class="drop-bottom">
      <p>切换账号</p>
      <ul>
        <li
          v-for="item in accounts"
          :key="item.accountId"
          :class="{ active: getActiveClass(item) }"
          @click="switchAccount(item)"
        >
          <div class="headSculpture">
            <img
              class="avatar"
              :src="
                item.avatar ||
                  require('../../assets/img/headers/drop/defaultHead.svg')
              "
              alt=""
            />
            <i class="icon" v-if="item.accountType === 'COMPANY'"></i>
          </div>
          <div class="user-info">
            <p class="nickName">{{ item.nickName }}</p>
            <div class="companyName">
              <img
                v-if="
                  [
                    'wechat_oauth',
                    'wechat_qr',
                    'wechat_official_qr',
                    'wechat_work_qr',
                    'wechat_mini_program',
                    'wechat_mini_program_code'
                  ].includes(item.authType)
                "
                src="../../assets/img/headers/wechat.svg"
                alt=""
              />
              <img
                v-else-if="
                  ['qq_mobile_oauth', 'qq_oauth'].includes(item.authType)
                "
                src="../../assets/img/headers/qq.svg"
                alt=""
              />
              <img
                v-else-if="item.authType === 'foxit_oauth'"
                src="../../assets/img/headers/foxit.svg"
                alt=""
              />
              <img
                v-else-if="
                  ['weibo_oauth', 'weibo_mobile_oauth'].includes(item.authType)
                "
                src="../../assets/img/headers/weibo.svg"
                alt=""
              />
              <img
                v-else-if="item.authType === 'sms'"
                src="../../assets/img/headers/phone.svg"
                alt=""
              />
              <img v-else src="../../assets/img/headers/lock.svg" alt="" />
              <span>{{
                item.accountType === "PERSONAL" ? "个人账号" : item.companyName
              }}</span>
            </div>
          </div>
          <img
            class="right"
            src="../../assets/img/headers/icon_right.png"
            alt=""
          />
        </li>
      </ul>
      <div class="signOut" @click="signOut">
        <img src="../../assets/img/headers/drop/exit.png" alt="退出" />
        <span>退出登录</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { headerMixin } from "../../mixins/headerMixin";
import { getMineAccounts, findPrintVipUser, getCurrentUser } from "api/api.js";
import { logout } from "../../utils/utils.js";

export default {
  data() {
    return {
      loginType: localStorage.getItem("loginType"),
      notCors: false,
      isCertification: true,
      showCertification: true,
      currentUser: null
    };
  },
  mixins: [headerMixin],
  computed: {
    ...mapState("user", ["accessToken", "userInfo"]),
    percentage() {
      return this.maxSize - this.currentSize <= 0
        ? 100
        : (this.currentSize / this.maxSize) * 100;
    }
  },
  mounted() {
    this.getVipInfo();
    this.getAccounts();
    this.isCertificatePhone();
  },
  methods: {
    ...mapMutations("user", ["UPDATE_MAX_SIZE", "UPDATE_ACCOUNTS"]),
    closeCertification() {
      this.showCertification = false;
    },
    getActiveClass(userInfo) {
      if (this.accounts.length === 1) return true;
      return userInfo.isCurrent;
    },
    async getAccounts() {
      if (!this.userInfo) return;
      try {
        if (this.loginType === "iam") {
          const res = await getMineAccounts();
          if (res.code === 0) {
            this.UPDATE_ACCOUNTS(res.data);
          }
        } else {
          this.UPDATE_ACCOUNTS([this.userInfo]);
        }
      } catch (e) {
        this.notCors = false;
      }
    },
    async getVipInfo() {
      if (this.userInfo.accountType === "COMPANY") return;
      try {
        const { data } = await findPrintVipUser();
        this.userVipInfo = data;
      } catch (e) {
        console.log(e);
      }
    },
    //退出登录
    signOut() {
      logout();
    },
    async isCertificatePhone() {
      if (this.loginType === "iam") {
        const res = await getCurrentUser();
        if (res.code === 0) this.currentUser = res.data;
        if (res.code === 0 && !res.data.phoneVerified) {
          this.isCertification = false;
        }
      }
    },
    switchAccount(account) {
      if (account.isCurrent || this.accounts.length === 1) return;
      const accountId = account.accountId;
      window.location.href = `https://account.foxitreader.cn/switch?accountId=${accountId}&cb=${encodeURIComponent(
        window.location.href
      )}&redirectUrl=${encodeURIComponent(
        "https://www.foxitcloud.cn/singleSign"
      )}`;
    },
    increase() {
      window.location.href = "https://work.foxitcloud.cn/pay/cloudDocumentPay";
    }
  }
};
</script>

<style lang="scss" scoped>
.dropDown {
  width: 380px;
  opacity: 1;
  background: #fff;
  z-index: 9999;
  .drop-top {
    background: #ffffff;
    padding: 16px 22px 20px;
    .drop-header {
      display: flex;
      align-items: center;
      img.defaultHead {
        width: 50px;
        height: 50px;
        margin-right: 18px;
        border-radius: 25px;
      }
      .info-box {
        display: flex;
        flex-direction: column;
        .top {
          display: flex;
          align-items: center;
          h2 {
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            max-width: 190px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 6px;
            line-height: 21px;
          }
          span {
            display: block;
            font-size: 12px;
            border-radius: 14px 14px 14px 14px;
            margin-right: 6px;
            padding: 0 6px;
            box-sizing: border-box;
            height: 20px;
            line-height: 20px;
          }
          span.normal {
            background: #d9e2f7;
            color: #5d6a81;
          }
          span.vip {
            color: #865435;
            background: #fbe0b9;
          }
        }
        .bottom {
          display: flex;
          align-items: center;
          margin-top: 6px;
          > div {
            display: flex;
            align-items: center;
          }
          .icon {
            display: block;
            width: 18px;
            height: 18px;
            margin-right: 4px;
          }
          span {
            font-size: 13px;
            color: #666666;
          }
          > span.id {
            display: flex;
            align-items: center;
            height: 18px;
            &::before {
              display: block;
              content: "";
              margin: 0 8px;
              width: 1px;
              height: 12px;
              background: #cccccc;
            }
          }
        }
      }
    }
    .equity-box {
      padding: 18px 15px 18px 20px;
      margin-top: 16px;
      display: flex;
      height: 80px;
      box-sizing: border-box;
      align-items: center;
      justify-content: space-between;
      > div {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        h6 {
          color: #ffe8c4;
          font-size: 16px;
          margin-bottom: 8px;
        }
        p {
          font-size: 12px;
          color: #ffe8c4;
          > a {
            display: inline-block;
            font-size: 12px;
            color: #ffe8c4;
            text-decoration: underline;
            &:hover {
              color: #ffffff;
            }
          }
        }
      }
      > a {
        display: block;
        width: 72px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: linear-gradient(142deg, #fbffd9 0%, #ffb790 100%);
        border-radius: 16px 16px 16px 16px;
        font-size: 12px;
        color: #361f02;
        font-weight: bold;
        &:hover {
          background: linear-gradient(110deg, #ffdd9b 0%, #ffb389 100%);
        }
      }
      .vip {
        color: #602200;
      }
      .expiredTime {
        font-size: 12px;
        color: #bca382;
      }
    }
    .normal-bg {
      background: url("../../assets/img/headers/drop/equity-normal.png")
        no-repeat center;
      border-radius: 4px 4px 4px 4px;
    }
    .equity-vip {
      background: url("../../assets/img/headers/drop/equity-vip.png") no-repeat
        center;
      border-radius: 4px 4px 4px 4px;
    }
    .warn-tip {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 336px;
      height: 24px;
      background: #fbf6e1;
      margin-top: 12px;
      padding: 6px 7px;
      .warn-tip-text {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #ff9c00;
        > img {
          margin-right: 5px;
        }
        a {
          font-size: 12px;
          color: #ff9c00;
          text-decoration: underline;
          &:hover {
            color: #ff7600;
          }
        }
      }
      .close {
        cursor: pointer;
      }
    }
  }
  .vip-bg {
    background: url("../../assets/img/headers/drop/drop-top-background.png")
      no-repeat;
  }
  .drop-bottom {
    padding: 18px 20px 16px;
    background: #fafafa;
    p {
      font-size: 12px;
      text-align: left;
      margin-bottom: 15px;
    }
    ul {
      max-height: 174px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 5px;
        height: 10px;
      }
      &::-webkit-scrollbar-track {
        background: #fafafa;
        border-radius: 2px;
      }
      &::-webkit-scrollbar-thumb {
        background: #cccccc;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #cccccc;
      }
      li {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 10px 12px;
        height: 56px;
        position: relative;
        margin-bottom: 6px;
        .headSculpture {
          position: relative;
          margin-right: 20px;
          .avatar {
            width: 32px;
            height: 32px;
            border-radius: 16px;
          }
          .icon {
            display: block;
            background: url("../../assets/img/headers/drop/enterprise-icon.png")
              no-repeat center;
            background-size: 100%;
            width: 16px;
            height: 16px;
            position: absolute;
            right: -8px;
            bottom: 0;
          }
        }
        .user-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .nickName {
            color: #333333;
            font-size: 14px;
            line-height: 16px;
            display: inline-block;
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 4px;
          }
          .companyName {
            display: flex;
            align-items: center;
            color: #666666;
            img {
              margin-right: 2px;
              width: 16px;
            }
            span {
              font-size: 12px;
              line-height: 18px;
              display: inline-block;
              max-width: 200px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        > img.right {
          position: absolute;
          right: 12px;
          top: 50%;
          margin-top: -5px;
          display: none;
          width: 16px;
          height: 16px;
        }
        &:hover {
          background: #f0f4fa;
          border-radius: 4px 4px 4px 4px;
        }
      }
      li.active {
        background: #f0f4fa;
        border-radius: 4px 4px 4px 4px;
        > img.right {
          display: block;
        }
      }
    }
    .signOut {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 10px 12px;
      height: 56px;
      margin-top: 6px;
      img {
        margin-right: 20px;
      }
      span {
        color: #333333;
        font-size: 14px;
      }
      &:hover {
        background: #f0f4fa;
        border-radius: 4px 4px 4px 4px;
      }
    }
  }
}

.tabulation {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  padding: 0 10px 20px;
  li {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 84px;
    img {
      width: 24px;
      height: 24px;
    }
    a {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 12px;
        color: #333333;
        margin-top: 8px;
      }
    }
  }
}

.pb0 {
  padding-bottom: 0 !important;
}
</style>
